module.exports = __webpack_public_path__ + "img/docker.f54c0ed0.svg";